import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MedicineService } from 'src/core/services/medicine.service';
import { CreatePackageTypePayload, PackageType } from 'src/interfaces/medicine';

export interface DialogData {
  title: string;
  message: string;
}

@Component({
    selector: 'app-package-type-create-dialog',
    templateUrl: './package-type-create-dialog.component.html',
    styleUrls: ['./package-type-create-dialog.component.scss'],
    standalone: false
})
export class PackageTypeCreateDialogComponent implements OnInit {
  
  packageTypeForm = this._formBuilder.group({
    type: ['', Validators.required],
    code: ['', Validators.required]
  });

  constructor(
    public _dialogRef: MatDialogRef<PackageTypeCreateDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private _formBuilder: UntypedFormBuilder,
    private _medicineService: MedicineService
  ) { }

  ngOnInit(): void {
  }

  async createPackageType() {

    const payload: CreatePackageTypePayload = {
      type: this.packageTypeForm.value.type,
      code: this.packageTypeForm.value.code,
    };

    const createdPackageType: PackageType | null = await this._medicineService
      .createPackageType(payload)

    if (createdPackageType)
      this._dialogRef.close(createdPackageType);
  }

}
